// @tennis-matches/services/supabase
// Merkt sich fehlende PostgREST-Routen (404), damit keine wiederholten Netzwerk-Fehler in der Konsole entstehen.

const STORAGE_KEY = "tm.rest.unavailable.v2";

function __readKeys() {
  try {
    if (typeof localStorage === "undefined") return new Set();
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = JSON.parse(raw || "[]");
    return new Set(Array.isArray(parsed) ? parsed.map((k) => String(k || "").trim()).filter(Boolean) : []);
  } catch {
    return new Set();
  }
}

function __writeKeys(set) {
  try {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
  } catch (_) {}
}

/**
 * @param {string} key z. B. `rpc:is_superadmin`, `table:club_people`, `rpc:list_role_app_access:global:global`
 */
export function isRestEndpointUnavailable(key) {
  const k = String(key || "").trim();
  if (!k) return false;
  return __readKeys().has(k);
}

/** @param {string} key */
export function markRestEndpointUnavailable(key) {
  const k = String(key || "").trim();
  if (!k) return;
  const set = __readKeys();
  if (set.has(k)) return;
  set.add(k);
  __writeKeys(set);
}

export function clearRestEndpointAvailabilityCache() {
  try {
    if (typeof localStorage !== "undefined") localStorage.removeItem(STORAGE_KEY);
  } catch (_) {}
}

/** @param {string} key */
export function clearRestEndpointUnavailable(key) {
  const k = String(key || "").trim();
  if (!k) return;
  const set = __readKeys();
  if (!set.has(k)) return;
  set.delete(k);
  __writeKeys(set);
}

/**
 * PostgREST/Supabase: Tabelle oder RPC nicht exponiert (kein erneuter Request nötig).
 * @param {unknown} error
 */
/**
 * PostgREST/DB: wiederholte Requests vermeiden (z. B. RLS-Rekursion → HTTP 500).
 * @param {unknown} error
 */
export function isRestEndpointServerError(error) {
  if (!error) return false;
  const status = Number(error?.status ?? error?.statusCode ?? 0);
  if (status >= 500 && status < 600) return true;
  const msg = String(error?.message ?? error).toLowerCase();
  return msg.includes("internal server error") || msg.includes("database error");
}

export function isMissingRestResourceError(error) {
  if (!error) return false;
  const status = Number(error?.status ?? error?.statusCode ?? 0);
  if (status === 404) return true;
  const code = String(error?.code ?? "").trim();
  if (code === "PGRST202" || code === "PGRST116" || code === "42883" || code === "42P01" || code === "42703") {
    return true;
  }
  const msg = String(error?.message ?? error).toLowerCase();
  if (msg.includes("404")) return true;
  if (msg.includes("could not find")) return true;
  if (msg.includes("schema cache")) return true;
  if (msg.includes("function not found")) return true;
  if (msg.includes("relation") && msg.includes("does not exist")) return true;
  return false;
}

/** PostgREST: `app_config` nicht in Exposed Schemas (kein erneuter Schema-REST nötig). */
export function isAppConfigSchemaUnavailableError(error) {
  if (!error) return false;
  const code = String(error?.code ?? "").trim();
  const status = Number(error?.status ?? error?.statusCode ?? 0);
  const msg = String(error?.message ?? error).toLowerCase();
  return (
    code === "PGRST106" ||
    status === 406 ||
    msg.includes("schema must be") ||
    msg.includes("invalid schema")
  );
}

export const APP_CONFIG_SCHEMA_REST_KEY = "schema:app_config";
